/**
 * Compare two lists deeply to see if they are equal
 *
 * @param list1 list to compare
 * @param list2 list to compare
 * @returns
 */
function isListEqual(list1: any[], list2: any[]): boolean {
  if (list1.length !== list2.length) {
    return false;
  }

  for (let i = 0; i < list1.length; i++) {
    if (!isDeepEqual(list1[i], list2[i])) {
      return false;
    }
  }

  return true;
}

/**
 * Compare two objects deeply to see if they are equal
 *
 * @param obj1 object to compare
 * @param obj2 object to compare
 * @returns
 */
function isDeepEqual(obj1: any, obj2: any): boolean {
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return obj1 === obj2;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (!isDeepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export { isListEqual, isDeepEqual };
